/**
 * NetSuite receiving status for a PO, as shown in the PO list's "NetSuite"
 * column. The server maps NetSuite's own status code to `receivingStatus`;
 * "not_in_netsuite" is added only after a successful lookup finds no match.
 */

export type NetSuiteReceivingStatus =
  | "pending_approval"
  | "rejected"
  | "not_received"
  | "partially_received"
  | "received"
  | "received_billed"
  | "closed";

export type NetSuiteColumnStatus = NetSuiteReceivingStatus | "not_in_netsuite" | "unknown";

type ChipColor = "default" | "primary" | "success" | "warning" | "error" | "info";

export const NETSUITE_STATUS_DISPLAY: Record<NetSuiteColumnStatus, { label: string; color: ChipColor; help: string }> = {
  not_in_netsuite: { label: "Not found in NetSuite", color: "default", help: "No NetSuite purchase order matched this full PO number. Combined or differently numbered orders may need manual review." },
  pending_approval: { label: "Awaiting approval", color: "warning", help: "NetSuite is waiting for a supervisor to approve the PO before anything can be received against it." },
  rejected: { label: "Rejected", color: "error", help: "A supervisor rejected the PO in NetSuite." },
  not_received: { label: "Not received", color: "default", help: "In NetSuite, nothing has been received against this PO yet." },
  partially_received: { label: "Partially received", color: "warning", help: "NetSuite has an item receipt for some, but not all, of the PO's quantity." },
  received: { label: "Received", color: "success", help: "NetSuite has received the full quantity; the vendor bill is still pending." },
  received_billed: { label: "Received · billed", color: "success", help: "NetSuite has received the full quantity and the vendor bill is entered." },
  closed: { label: "Closed", color: "default", help: "The PO was closed in NetSuite; any unreceived quantity will not arrive." },
  unknown: { label: "Unknown status", color: "warning", help: "NetSuite reported a status this tool does not recognise." },
};
